module.exports = __webpack_public_path__ + "static/media/Gotham-UltraItalic.41de9e77.ttf";